//@flow
import {
    validateEntityIds as validateEntityIdsApi,
    skill as skillApi
} from 'common/middleware/api';
import { showToast } from 'common/redux/actions/toast';
import { ToastTypes } from 'common/components/core/toast/Toast';
import EntityActions from 'common/redux/actions/EntityActions';
import I18nHelper from 'common/helpers/I18nHelper';

import type { Skill } from 'common/models/internal/Skill';

import type { Dispatch } from 'redux';

type Params = {
    clientId: string,
    skillId?: string,
    overwrite?: boolean
};

const translationsNamespace = ['entityManagement'];
const nsTranslate = I18nHelper.getTranslate(translationsNamespace);

const ENTITY_NAME_ID = 'skill';
class SkillActions extends EntityActions<Skill, Params> {
    superFetchEntities = this.fetchEntities;

    fetchEntities = (params: { clientId: string }, _options = {}) => {
        return (dispatch: Dispatch<*>) => {
            const options = {
                processResponse: (response: any) =>
                    (response.skills: Array<Object>)
            };
            dispatch(this.superFetchEntities(params, options));
        };
    };

    superAddEntity = this.addEntity;

    addEntity = (
        params: { clientId: string, skillId: string },
        entity: Skill,
        _options = {}
    ) => {
        return (dispatch: Dispatch<*>) => {
            return new Promise((resolve, reject) => {
                const options = {
                    onSuccess: (skill: Skill) => {
                        const toast = {
                            message: nsTranslate('addEntitySuccessMessage', {
                                entityNameId: ENTITY_NAME_ID
                            }),
                            type: ToastTypes.Success
                        };
                        dispatch(showToast(toast, params));
                        resolve(skill);
                    },
                    onFailure: (error: Error) => {
                        reject(error);
                    },
                    dontInjectError: true
                };
                dispatch(this.superAddEntity(params, entity, options));
            });
        };
    };
}

export default new SkillActions(
    'Skill',
    skillApi,
    null,
    null,
    validateEntityIdsApi
);
